import React from 'react';
import { FAQItem } from './FAQItem';
import { Highlight } from './ui/HeroHighlight';
import { BookCallButton } from './ui/BookCallButton';
export const FAQSection = () => {
  const scrollToCalendly = () => {
    const element = document.getElementById('calendly');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const faqs = [{
    question: 'How is this different from every other recruiting agency?',
    answer: "Most agencies dump a pile of applicants on your lap and walk away. We don't. We run the entire process—from job listings to triple-screened final interviews booked right onto your calendar. You only show up to interview qualified, commission-ready reps. We also train you on our proprietary onboarding system so reps launch fast and drive real profit."
  }, {
    question: "What happens if I don't see results in the first 30 days?",
    answer: "If you meet the ad budget minimum, and we don't generate strong early results, we keep working for free until we do. This isn't a gamble—it's a recruiting engine built to win fast or keep grinding until it does."
  }, {
    question: 'Who is this system best for?',
    answer: "We primarily work with door-to-door solar and roofing companies doing at least $2M in annual revenue, with strong field leadership and the infrastructure to handle 20+ hires per month. If you're ready to scale and can support rep growth operationally, this is built for you."
  }, {
    question: 'Do I need to change how I run my business or hire new managers?',
    answer: "No. You don't need recruiters or extra staff. We plug into your current workflow. You manage the growth—we build, manage, and optimize the system. You own the results."
  }, {
    question: 'How fast does it work?',
    answer: "Our first client hired over 20 fully commission-ready reps in just 10 days. Triple-screened final interviews land on your calendar within days of launch—not months. It's not a slow drip—it's a fully operational recruiting machine."
  }];
  return;
};